module.exports = __webpack_public_path__ + "img/loading.c5590569.svg";